/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Autocomplete module
 */
import { filterActions } from '@zumper/redux-ignore'
import rootReducer from './reducers'
import whitelist from './reducers/whitelist'

export { whitelist }
export default filterActions(rootReducer, whitelist)
